class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.notification.addEventListener("keyup", (evt) => evt.code === "Escape" && this.close());
    this.querySelectorAll('button[type="button"]').forEach(
      (closeButton) => closeButton.addEventListener("click", this.close.bind(this))
    );
  }
  open() {
    this.notification.classList.add("animate", "active");
    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );
    document.body.addEventListener("click", this.onBodyClick);
  }
  close() {
    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }
  renderContents(parsedState) {
    var _a, _b;
    if (!parsedState || !parsedState.key || !parsedState.sections) return;
    this.cartItemKey = parsedState.key;
    const sectionsToRender = (_a = this.getSectionsToRender) == null ? void 0 : _a.call(this);
    if (Array.isArray(sectionsToRender)) {
      sectionsToRender.forEach((section) => {
        var _a2;
        const sectionHTML = parsedState.sections[section.id];
        const targetElement = document.getElementById(section.id);
        if (sectionHTML && targetElement) {
          targetElement.innerHTML = ((_a2 = this.getSectionInnerHTML) == null ? void 0 : _a2.call(this, sectionHTML, section.selector)) || "";
        }
      });
    }
    if ((_b = this.header) == null ? void 0 : _b.reveal) this.header.reveal();
    if (this.open) this.open();
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      },
      {
        id: "cart-notification-button"
      },
      {
        id: "cart-icon-bubble"
      }
    ];
  }
  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector).innerHTML;
  }
  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure, header-menu");
      this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
      this.close();
    }
  }
  setActiveElement(element) {
    this.activeElement = element;
  }
}
customElements.define("cart-notification", CartNotification);
